import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  apiGetAllProcess,
  apiGetAllProduct,
  apiGetAllWorker,
  apiPostAllProduction,
  apiGetAllProduction,
  apiProductionPlan,
  apiDeleteProductionPlan,
} from "../../../services/ProductionplanningService";

export const getProcess = createAsyncThunk(
  "production/data/getProcess",
  async (data) => {
    try {
      const response = await apiGetAllProcess(data);
      return response.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const getProduct = createAsyncThunk(
  "production/data/getProduct",
  async (data) => {
    try {
      const response = await apiGetAllProduct(data);
      return response.data;
    } catch (error) {
      return error.message;
    }
  }
);
export const getWorker = createAsyncThunk(
  "production/data/getWorker",
  async (data) => {
    try {
      const response = await apiGetAllWorker(data);
      return response.data;
    } catch (error) {
      return error.message;
    }
  }
);
export const getallProduction = createAsyncThunk(
  "production/data/getProduction",
  async (data) => {
    try {
      const response = await apiGetAllProduction(data);
      return response.data;
    } catch (error) {
      return error.message;
    }
  }
);
export const postProduction = createAsyncThunk(
  "production/data/postProduction",
  async (data) => {
    try {
      const response = await apiPostAllProduction(data);
      return response;
    } catch (error) {
      return error.message;
    }
  }
);

export const updateProduction = createAsyncThunk(
  "production/data/putProduction",
  async (data) => {
    try {
      const response = await apiPostAllProduction(data);
      return response;
    } catch (error) {
      return error.message;
    }
  }
);
export const deleteProduction = createAsyncThunk(
  "production/data/deleteProduction",
  async (data) => {
    try {
      const response = await apiDeleteProductionPlan(data);
      return response.data;
    } catch (error) {
      return error.message;
    }
  }
);
export const detailProduction = createAsyncThunk(
  "production/data/detailProduction",
  async (data) => {
    try {
      const response = await apiProductionPlan(data);
      return response.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const initialTableData = {
  total: 0,
  pageIndex: 1,
  pageSize: 10,
  query: "",
  sort: {
    order: "",
    key: "",
  },
};

export const initialFilterData = {
  name: "",
  category: ["bags", "cloths", "devices", "shoes", "watches"],
  status: [0, 1, 2],
  productStatus: 0,
};

const dataSlice = createSlice({
  name: "productionList/data",
  initialState: {
    loading: false,
    processList: [],
    productList: [],
    productionList: [],
    detailProduction: {},
    workerList: [],
    tableData: initialTableData,
    filterData: initialFilterData,
  },
  reducers: {
    updateProductList: (state, action) => {
      state.employeeList = action.payload;
    },
    setTableData: (state, action) => {
      state.tableData = action.payload;
    },
    setFilterData: (state, action) => {
      state.filterData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProcess.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getProcess.fulfilled, (state, action) => {
      state.loading = false;
      state.processList = action.payload;
    });
    builder.addCase(getProduct.fulfilled, (state, action) => {
      state.productList = action.payload;
    });
    builder.addCase(getWorker.fulfilled, (state, action) => {
      state.workerList = action.payload;
    });
    builder.addCase(getallProduction.fulfilled, (state, action) => {
      state.productionList = action.payload;
    });
    builder.addCase(postProduction.fulfilled, (state, action) => {});
    builder.addCase(updateProduction.fulfilled, (state, action) => {});
    builder.addCase(deleteProduction.fulfilled, (state, action) => {});
    builder.addCase(detailProduction.fulfilled, (state, action) => {
      state.detailProduction = action.payload.data;
    });
  },
});

export const { updateProductList, setTableData, setFilterData } =
  dataSlice.actions;

export default dataSlice.reducer;
